import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { ModalBody, Modal, ModalHeader, PrevIcon, NextIcon } from '../../../../../components';
import Slider from 'react-slick';
import classes from './videoComponent.module.css';
import { addScrollToBody, removeScrollFromBody } from '../../../../../hooks/utils';

function VideoComponent(_ref) {
  var isOpen = _ref.isOpen,
      closeDrawer = _ref.closeDrawer,
      videoGallery = _ref.videoGallery,
      videoName = _ref.videoName;

  var CustomPrevArrow = function CustomPrevArrow(props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick;
    return React.createElement("div", {
      className: className,
      style: style,
      onClick: onClick
    }, React.createElement(PrevIcon, null));
  };

  var CustomNextArrow = function CustomNextArrow(props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick;
    return React.createElement("div", {
      className: className,
      style: style,
      onClick: onClick
    }, React.createElement(NextIcon, null));
  };

  var settings = {
    inifinite: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: React.createElement(CustomNextArrow, null),
    prevArrow: React.createElement(CustomPrevArrow, null)
  };
  useEffect(function () {
    removeScrollFromBody();
    return function () {
      return addScrollToBody();
    };
  }, [isOpen]);
  return React.createElement(Modal, {
    isOpen: isOpen,
    toggleModal: closeDrawer,
    classes: {
      modalWrapper: classes.modalWrapper
    },
    size: "full"
  }, React.createElement(ModalHeader, {
    title: '',
    classes: {
      root: classes.modalHeader
    },
    closeModal: closeDrawer
  }), React.createElement(ModalBody, {
    classes: {
      root: classes.body
    }
  }, React.createElement(Slider, _extends({}, settings, {
    className: classes.sliderWrapper
  }), videoGallery === null || videoGallery === void 0 ? void 0 : videoGallery.map(function (video) {
    return React.createElement("iframe", {
      id: "popup-video",
      title: "".concat(videoName, " video"),
      width: "420",
      height: "420",
      src: video
    });
  }))));
}

export default VideoComponent;